import React, { Component } from 'react';
import { Dropdown, Drawer } from 'antd';
import {
    QuestionCircleOutlined,
    DownOutlined,
    MenuOutlined,
    HomeOutlined,
    MailOutlined,
    SettingOutlined,
    CreditCardOutlined,
    TeamOutlined,
    LineChartOutlined
} from '@ant-design/icons';
import Inherit from '../../../core/inherit';
import withHooks from '../../../core/withHooks';
import HeaderController from './header.controller';
import styles from './styles/header.module.scss';

class Header extends Inherit(HeaderController, Component) {
    render() {
        const { user, dropdownOpen, drawerOpen } = this.state;

        const userMenuItems = [
            {
                key: 'account',
                label: 'Account'
            },
            {
                type: 'divider'
            },
            {
                key: 'logout',
                label: 'Log out',
                danger: true
            }
        ];

        const menuItems = [
            {
                key: 'home',
                label: 'Home',
                icon: <HomeOutlined />,
                route: '/dashboard'
            },
            {
                key: 'cashflow',
                label: 'Cashflow Management',
                icon: <MailOutlined />,
                route: '/treasury'
            },
            {
                key: 'configurations',
                label: 'Configurations',
                icon: <SettingOutlined />,
                route: '/configurations'
            },
            {
                key: 'billing',
                label: 'Billing',
                icon: <CreditCardOutlined />,
                route: '/billing'
            },
            {
                key: 'team',
                label: 'Team',
                icon: <TeamOutlined />,
                route: '/team'
            },
            {
                key: 'reports',
                label: 'Reports',
                icon: <LineChartOutlined />,
                route: '/reports'
            }
        ];

        return (
            <header className={styles.header}>
                <div className={styles.headerLeft}>
                    <button className={styles.menuButton} onClick={this.handleMenuClick} aria-label="Menu">
                        <MenuOutlined />
                    </button>
                    <div className={styles.logoContainer}>
                        <img src="/logo.png" alt="Clockout" className={styles.logo} />
                    </div>
                </div>

                <div className={styles.headerRight}>
                    <button className={styles.supportButton} onClick={this.handleSupportClick}>
                        <QuestionCircleOutlined />
                        <span>Contact Support</span>
                    </button>

                    <div className={styles.userSection}>
                        <Dropdown
                            menu={{
                                items: userMenuItems,
                                onClick: this.handleUserMenuClick
                            }}
                            placement="bottomRight"
                            trigger={['click']}
                            onOpenChange={this.handleDropdownVisibleChange}>
                            <div className={styles.userMenu}>
                                <span className={`${styles.userName} ${dropdownOpen ? styles.userNameOpen : ''}`}>{user?.name || 'User Name'}</span>
                                <DownOutlined className={`${styles.dropdownArrow} ${dropdownOpen ? styles.dropdownArrowOpen : ''}`} />
                            </div>
                        </Dropdown>
                    </div>
                </div>

                <Drawer title="Menu" placement="left" onClose={this.handleDrawerClose} open={drawerOpen} className={styles.mobileDrawer} width={280}>
                    <nav className={styles.drawerNavigation}>
                        {menuItems.map((item) => (
                            <button
                                key={item.key}
                                className={`${styles.drawerNavItem} ${this.state.activeItem === item.key ? styles.active : ''}`}
                                onClick={() => this.handleDrawerItemClick(item.key, item.route)}>
                                <div className={styles.drawerIconContainer}>{item.icon}</div>
                                <span className={styles.drawerLabel}>{item.label}</span>
                            </button>
                        ))}
                    </nav>
                </Drawer>
            </header>
        );
    }
}

export default withHooks(Header);
